import { isPublicShellPath } from "./publicShellPaths";

export const SESSION_EXPIRED_EVENT = "auth:session-expired";

let logoutInFlight = false;

/** Trigger a single shared logout for a dead UI session. Safe to call from many 401s. */
export function requestSessionExpiredLogout() {
  if (logoutInFlight) return;
  if (typeof window === "undefined") return;
  if (isPublicShellPath(window.location.pathname)) return;

  logoutInFlight = true;
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
}

/** Allow a later session to force-logout again after logout/login completes. */
export function resetSessionExpiredLogoutGuard() {
  logoutInFlight = false;
}
